<script setup>
import ConnectorCellPicker from "./ConnectorCellPicker.vue";
defineProps({
  connectors: {
    type: Array,
    required: true
  },
  s3Url: {
    type: String,
    required: true
  },
  legacyApiUrl: {
    type: String,
    required: true
  },
  hasIncompatibility: {
    type: Boolean,
    default: false
  }
});
defineEmits(["selectConnector"]);
</script>

<template>
    <div class="w-full flex flex-col gap-6 items-center">
        <span
            class="text-[17px] 425:text-[22px] text-header-dark font-bold leading-5 425:leading-[25px]"
        >
            {{ $t("simulation.connectors_list.title") }}
        </span>
        <div class="w-full flex flex-col gap-6 pt-8 items-center">
            <img
                :src="`${s3Url}/simulator/ConnectorFront1.png`"
                :alt="$t('simulation.connectors_list.image_alt')"
                class="w-[170px] h-[130px]"
            />
            <span
                class="w-full text-[17px] 425:text-[22px] text-left text-gray-l-800 font-bold leading-5 425:leading-[25px] pt-2"
            >
                {{ $t("simulation.connectors_list.subtitle") }}
            </span>
            <div class="w-full flex flex-col gap-2 items-center">
                <ConnectorCellPicker
                    v-for="connector in connectors"
                    :key="connector.id"
                    :connector
                    :legacyApiUrl
                    :is-selected="connector.isSelected"
                    :is-disabled="connector.isIncompatible"
                    is-standalone
                    @selectConnector="
  ($event) => $emit('selectConnector', $event)
"
                />
            </div>
            <div
                v-if="hasIncompatibility"
                class="w-full flex items-start p-1 gap-1"
            >
                <IconInfoCircle
                    isSolid
                    class="size-4 text-icon-secondary-neutral"
                />
                <span
                    class="text-[11px] 425:text-[13px] text-gray-l-500 font-normal leading-4"
                >
                    {{ $t("simulation.connectors_list.incompatibility") }}
                </span>
            </div>
        </div>
    </div>
</template>
